// Miky Motorsport - definice aut (M1b: parametry pro vlastni slip-based sim)

// Zakladni spec (Veza Spark) - ostatni auta z nej derivuji pres makeCar (DRY + bezpecne).
const BASE = {
  id: 'veza_spark',
  name: 'Veza Spark',
  brand: 'Veza',
  cls: 'D',
  drive: 'FWD',

  // Chassis: half-extents (m), hmotnost (kg), posun teziste
  chassis: { hx: 0.86, hy: 0.5, hz: 1.95, mass: 1050, comY: -0.32 },

  // Kola
  wheel: {
    radius: 0.36, // efektivni valivy polomer (m)
    width: 0.28,
    inertia: 1.1, // moment setrvacnosti kola (kg*m^2)
    // FL, FR, RL, RR (connection point relativne k chassis centru)
    positions: [
      { x: -0.86, y: -0.30, z: 1.32 },
      { x: 0.86, y: -0.30, z: 1.32 },
      { x: -0.86, y: -0.30, z: -1.28 },
      { x: 0.86, y: -0.30, z: -1.28 },
    ],
  },

  // Suspension (vlastni model: pruzina+tlumic, SI jednotky)
  suspension: {
    restLength: 0.45,
    stiffness: 55000,
    damping: 4500,
    maxForce: 18000,
    margin: 0.12,
  },

  // Pneumatiky (simplified Pacejka)
  tire: {
    muLong: 1.15, muLat: 1.15,
    Blong: 9.0, Clong: 1.65, Blat: 12.0, Clat: 1.45, E: 0.97,
    pneumaticTrail: 0.045, satCoef: 1.1,
  },

  // Motor (torque krivka RPM -> Nm)
  engine: {
    idleRpm: 900,
    redlineRpm: 6600,
    torqueCurve: [
      [900, 110], [2000, 165], [3000, 195], [4000, 206],
      [4800, 200], [5600, 182], [6600, 148],
    ],
  },

  drivetrain: {
    gears: [3.45, 2.05, 1.4, 1.05, 0.82],
    reverseRatio: 3.6,
    finalDrive: 4.06,
    efficiency: 0.9,
    shiftUpRpm: 6100,
    shiftDownRpm: 2300,
  },

  brakes: { maxTorque: 1500, frontBias: 0.6, handbrakeTorque: 2600 },
  maxSteerDeg: 36,

  basePI: 92,
  price: 0,

  // Vizual
  model: 'q1',
  color: 0xff5e3a,
  accentColor: 0x141420,
  topSpeedKmh: 195,
};

// Deriv auta ze zakladu s modifikatory (vyssi trida = vic vykonu/gripu/brzd, min vahy).
function makeCar(id, o) {
  const c = structuredClone(BASE);
  c.id = id;
  c.name = o.name; c.brand = o.brand; c.cls = o.cls;
  c.drive = o.drive || c.drive;
  c.model = o.model; c.color = o.color;
  c.price = o.price; c.basePI = o.basePI;
  if (o.powerScale) c.engine.torqueCurve = c.engine.torqueCurve.map(([r, t]) => [r, Math.round(t * o.powerScale)]);
  if (o.redline) { c.engine.redlineRpm = o.redline; c.drivetrain.shiftUpRpm = o.redline - 500; }
  if (o.mass) c.chassis.mass = o.mass;
  if (o.muScale) { c.tire.muLong = +(c.tire.muLong * o.muScale).toFixed(3); c.tire.muLat = +(c.tire.muLat * o.muScale).toFixed(3); }
  if (o.brakeScale) c.brakes.maxTorque = Math.round(c.brakes.maxTorque * o.brakeScale);
  if (o.steer) c.maxSteerDeg = o.steer;
  if (o.topSpeedKmh) c.topSpeedKmh = o.topSpeedKmh;
  return c;
}

export const CARS = {
  veza_spark: BASE,
  // C: vyvazeny sedan
  kestrel_gt: makeCar('kestrel_gt', {
    name: 'Kestrel GT', brand: 'Kestrel', cls: 'C', drive: 'FWD', model: 'q2',
    color: 0x2e6cff, price: 24000, basePI: 128,
    powerScale: 1.28, redline: 6900, mass: 1010, muScale: 1.07, brakeScale: 1.15, topSpeedKmh: 225,
  }),
  // B: sportovni kupe (RWD)
  vortex_rs: makeCar('vortex_rs', {
    name: 'Vortex RS', brand: 'Vortex', cls: 'B', drive: 'RWD', model: 'q6',
    color: 0xe74c3c, price: 58000, basePI: 172,
    powerScale: 1.62, redline: 7400, mass: 960, muScale: 1.16, brakeScale: 1.34, steer: 38, topSpeedKmh: 268,
  }),
  // S: hyper (AWD)
  apex_x1: makeCar('apex_x1', {
    name: 'Apex X1', brand: 'Apex', cls: 'S', drive: 'AWD', model: 'q5',
    color: 0x9b59b6, price: 145000, basePI: 245,
    powerScale: 2.15, redline: 8200, mass: 890, muScale: 1.3, brakeScale: 1.6, steer: 40, topSpeedKmh: 318,
  }),

  // --- Rozsireny roster (G): 2 auta na tridu D-X ---
  // D: lehky hatchback
  pebble_gt: makeCar('pebble_gt', {
    name: 'Pebble GT', brand: 'Pebble', cls: 'D', drive: 'FWD', model: 'q3',
    color: 0x2ec4b6, price: 9000, basePI: 99,
    powerScale: 1.06, redline: 6700, mass: 1015, muScale: 1.03, brakeScale: 1.05, topSpeedKmh: 205,
  }),
  // C: lehky roadster
  mirage_s: makeCar('mirage_s', {
    name: 'Mirage S', brand: 'Mirage', cls: 'C', drive: 'RWD', model: 'q7',
    color: 0xf1c40f, price: 38000, basePI: 142,
    powerScale: 1.4, redline: 7000, mass: 985, muScale: 1.1, brakeScale: 1.22, steer: 38, topSpeedKmh: 240,
  }),
  // B: zadokolka kupe
  talon_r: makeCar('talon_r', {
    name: 'Talon R', brand: 'Talon', cls: 'B', drive: 'RWD', model: 'q6',
    color: 0x8e44ad, price: 82000, basePI: 188,
    powerScale: 1.82, redline: 7500, mass: 940, muScale: 1.2, brakeScale: 1.42, steer: 38, topSpeedKmh: 282,
  }),
  // A: GT kupe (RWD)
  falcon_gts: makeCar('falcon_gts', {
    name: 'Falcon GTS', brand: 'Falcon', cls: 'A', drive: 'RWD', model: 'q6',
    color: 0xe8483a, price: 125000, basePI: 212,
    powerScale: 1.96, redline: 7700, mass: 920, muScale: 1.25, brakeScale: 1.5, steer: 39, topSpeedKmh: 298,
  }),
  // A: AWD super
  comet_awd: makeCar('comet_awd', {
    name: 'Comet AWD', brand: 'Comet', cls: 'A', drive: 'AWD', model: 'q5',
    color: 0x2980d9, price: 175000, basePI: 236,
    powerScale: 2.06, redline: 8000, mass: 900, muScale: 1.3, brakeScale: 1.55, steer: 40, topSpeedKmh: 308,
  }),
  // S: AWD hyper
  tempest_s: makeCar('tempest_s', {
    name: 'Tempest S', brand: 'Tempest', cls: 'S', drive: 'AWD', model: 'q5',
    color: 0x27ae60, price: 250000, basePI: 272,
    powerScale: 2.3, redline: 8400, mass: 870, muScale: 1.34, brakeScale: 1.66, steer: 40, topSpeedKmh: 328,
  }),
  // X: hyper
  nova_x: makeCar('nova_x', {
    name: 'Nova X', brand: 'Nova', cls: 'X', drive: 'AWD', model: 'q5',
    color: 0xecf0f1, price: 420000, basePI: 312,
    powerScale: 2.6, redline: 8800, mass: 840, muScale: 1.4, brakeScale: 1.75, steer: 40, topSpeedKmh: 350,
  }),
  // X: vrcholny hyper
  zenith_x1: makeCar('zenith_x1', {
    name: 'Zenith X1', brand: 'Zenith', cls: 'X', drive: 'AWD', model: 'q5',
    color: 0xf39c12, price: 620000, basePI: 345,
    powerScale: 2.95, redline: 9200, mass: 820, muScale: 1.45, brakeScale: 1.85, steer: 40, topSpeedKmh: 375,
  }),
};

// Poradi pro garazni vyber (od nejlevnejsiho / dle tridy)
export const CAR_ORDER = [
  'veza_spark', 'pebble_gt', 'kestrel_gt', 'mirage_s', 'vortex_rs', 'talon_r',
  'falcon_gts', 'apex_x1', 'comet_awd', 'tempest_s', 'nova_x', 'zenith_x1',
];

export const DEFAULT_CAR = 'veza_spark';

export function getCar(id) {
  return CARS[id] || CARS[DEFAULT_CAR];
}
